import { render, staticRenderFns } from "./BookRepairMap.vue?vue&type=template&id=2013c4b8&"
import script from "./BookRepairMap.vue?vue&type=script&lang=js&"
export * from "./BookRepairMap.vue?vue&type=script&lang=js&"
import style0 from "./BookRepairMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports